export const EXPERIENCE = [
    {
        id: 7,
        name: "Technical Lead",
        description: "Led a culturally diverse team responsible for talent acquisition platforms using Angular and .NET Core 6. Increased applicant acquisition rate by 319% by automating HR interviews. Helped define and implement new architecture and domain for brand-new products.",
        date: "Sept 2021 - Present",
        location: "BairesDev - Remote",
        type: "job"
    },
    {
        id: 7,
        name: "Software Developer",
        description: "Developed banking system with Angular front-end and .NET Core back-end. Worked directly with clients in their native language (Spanish) using agile methodologies. Developed modular Angular libraries in order to standardize UI elements between applications",
        date: "Sept 2020 - Sept 2021",
        location: "Poatek",
        type: "job"
    },
    {
        id: 0,
        name: "Full-Stack Web Development with React Specialization",
        description: "The Hong Kong University of Science and Technology",
        date: "August 2020",
        location: "Coursera (online course)",
        type: "education"
    },
    {
        id: 1,
        name: "Master's Degree in Computer Science",
        description: "Federal University of Rio Grande do Sul",
        date: "2017 - 2020",
        location: "Porto Alegre, Brazil",
        type: "education"
    },
    {
        id: 2,
        name: "Software Developer",
        description: "University research project in partnership with Petrobras developing interface modules for the geochemical modelling of diagenetic processes. Development and design of user interfaces using C++ with Qt Framework. Modelling, implementing and managing of SQL database.",
        date: "2019 - 2020",
        location: "Porto Alegre, Brazil",
        type: "job"
    },
    {
        id: 3,
        name: "Researcher",
        description: "Development and design of web interfaces and visualizations to assist the clinical trial Lifestyle INtervention for Diabetes prevention After pregnancy (LINDA). The interface was developed using Javascript, HTML, Angular, Bootstrap, D3, PHP, PostgreSQL and Docker.",
        date: "2017 - 2019",
        location: "Porto Alegre, Brazil",
        type: "job"
    },
    {
        id: 4,
        name: "Bachelor's Degree in Computer Science",
        description: "Federal University of Rio Grande do Sul",
        date: "2012 - 2016",
        location: "Porto Alegre, Brazil",
        type: "education"
    },
    {
        id: 5,
        name: "Research Assistant",
        description: "Development and design of a visualization-based interface for TaxonomyBrowser, a biodiversity information system developed to assist biologists in the management of specimen data. The application has been programmed using Javascript, HTML, D3 and MySQL.",
        date: "2015 - 2016",
        location: "Porto Alegre, Brazil",
        type: "job"
    },
    {
        id: 6,
        name: "Part-time Software Developer",
        description: "University research project in partnership with Petrobras developing interface modules for the geochemical modelling of diagenetic processes. Development and design of user interfaces using C++ with Qt Framework. Modelling, implementing and managing of SQL database.",
        date: "2013 - 2015",
        location: "Porto Alegre, Brazil",
        type: "job"
    }
]